import { render, staticRenderFns } from "./DampingProducts.vue?vue&type=template&id=4638bb65&scoped=true&"
import script from "./DampingProducts.vue?vue&type=script&lang=js&"
export * from "./DampingProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638bb65",
  null
  
)

export default component.exports